import { useMemo } from "react";

import { useGetInfiniteConversations } from "@/api/agenticAI/useConversationsApi";
import { getChatBucket } from "@/components/agenticAI/chatHistoryBuckets";
import {
  AGENTIC_AI_UNTITLED_CHAT,
  type ChatHistoryEntry
} from "@/components/agenticAI/constants";

import dayjs from "dayjs";

export const useChatHistory = () => {
  const {
    data,
    isLoading,
    isError,
    isFetchNextPageError,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    refetch
  } = useGetInfiniteConversations();

  // A refetch with the same rows keeps the same `data`, so the day is a
  // dependency to regroup a tab that stays open past midnight.
  const today = dayjs().format("YYYY-MM-DD");

  const chats = useMemo<ChatHistoryEntry[]>(
    () =>
      (data?.pages ?? []).flatMap(({ conversations }) =>
        conversations.map(({ thread_id, title, updated_at }) => ({
          id: thread_id,
          title: title || AGENTIC_AI_UNTITLED_CHAT,
          bucket: getChatBucket(updated_at, dayjs(today))
        }))
      ),
    [data, today]
  );

  return {
    chats,
    isLoading,
    isInitialError: isError && chats.length === 0,
    isLoadMoreError: isFetchNextPageError,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    refetch
  };
};
